import { Autocomplete, Grid, TextField } from '@mui/material'
import React, { useContext, useEffect, useState } from 'react'
import styles from './../../../../assets/styles/componentStyles/manychatStyles/workflowFormComponents/workflowCreate.module.scss'
import globalStyles from './../../../../assets/styles/global.module.scss'
import { IntegrationContext, IntegrationContextPayload } from '../../../../context/integrationContext'
import { UserContext, UserContextPayload } from '../../../../context/userContext'
import { metaIntegrationPhoneNumberData, metaIntegrationWhatsAppDataNew } from '../../../../models/axiosModel'
import Required from '../../../utility/required'
import { WorkflowContext, WorkflowContextPayload } from '../../../../context/workflowContext'
import { isWhatsAppIntegration } from '../../../../pages/ruleBasedInbox/utils'

const WorkflowFacebookIntegration = () => {
    const { integrationListNewStructure, getMetaIntegrationList } = useContext(IntegrationContext) as IntegrationContextPayload;
    const { setFlagLoading, handleError, userDetail } = useContext(UserContext) as UserContextPayload
    const { createNewWorkflowPayload, setCreateNewWorkflowPayload } = useContext(WorkflowContext) as WorkflowContextPayload

    const [selectedWBA, setSelectedWBA] = useState<any>(null);
    const [selectedPhoneNumber, setSelectedPhoneNumber] = useState<metaIntegrationPhoneNumberData | null>(null);

    const onChangeOfWBA = (value: any) => {
        if (selectedPhoneNumber) {
            setSelectedPhoneNumber(null);
        }
        setSelectedWBA(value);
        setCreateNewWorkflowPayload({
            ...createNewWorkflowPayload,
            chatbot_channel_configuration: value ? {
                ...createNewWorkflowPayload.chatbot_channel_configuration, meta_integration_whatsapp_id: Number(value?.meta_integration_whatsapp_id),
            } : createNewWorkflowPayload?.chatbot_channel_configuration?.channel_content_type_id ? {
                channel_content_type_id: createNewWorkflowPayload?.chatbot_channel_configuration?.channel_content_type_id
            } : null
        })
    }

    const onChangeOfPhoneNumber = (value: any) => {
        setSelectedPhoneNumber(value);
        setCreateNewWorkflowPayload({
            ...createNewWorkflowPayload,
            chatbot_channel_configuration: {
                ...createNewWorkflowPayload.chatbot_channel_configuration, integrated_channel_id: value ? value?.integrated_channel_id : 0,
            }
        })
    }

    const getWhatsAppNumberOptions = () => {
        if (!integrationListNewStructure) return [];

        return integrationListNewStructure.filter(isWhatsAppIntegration)
            .find((waba: metaIntegrationWhatsAppDataNew) => waba.waba_id == selectedWBA.waba_id)
            ?.meta_integration_phone_number_data || [];
    }

    const getWhatsAppNumberValue = () => {
        const options = getWhatsAppNumberOptions();
        return options.find((phoneNumberData: any) => phoneNumberData.meta_integration_whatsapp_phone_number_id === selectedPhoneNumber?.meta_integration_whatsapp_phone_number_id) || null;
    }

    const getIntegrationListApiCall = async () => {
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: true }));
        const res = await getMetaIntegrationList(true)
        if (res.status) {
        } else {
            handleError(res);
        }
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: false }));
    }

    useEffect(() => {
        if (integrationListNewStructure !== null) return;
        (async () => {
            await getIntegrationListApiCall();
        })()
    }, [])

    return (
        <Grid item>
            <Grid container gap={"15px"}>
                <Grid item sx={{ width: "100%" }}>
                    <Grid container direction={"column"} gap={"10px"}>
                        <Grid item className={styles.createWorkflowLabelStyle}>WhatsApp Business Account</Grid>
                        <Grid item>
                            <Autocomplete
                                className={`${globalStyles.autocompleteParaphrasing} ${styles.autoComplete}`}
                                options={integrationListNewStructure ? integrationListNewStructure.filter((list: any) => list.channel_name.toLowerCase() === "whatsapp") : []}
                                getOptionLabel={(option: any) => option.waba_name ? option.waba_name : "WhatsApp Account"}
                                value={selectedWBA}
                                onChange={(_, value: any) => { onChangeOfWBA(value); }}
                                // disabled={checkDisableAllFields()}
                                renderInput={(params) => <TextField {...params} placeholder="Select WhatsApp Business Account" />}
                                sx={{ padding: "2px 4px !important" }}
                            />
                        </Grid>
                    </Grid>
                </Grid>

                {selectedWBA &&
                    <Grid item xs={12}>
                        <Grid container direction={"column"} gap={"10px"}>
                            <Grid item className={styles.createWorkflowLabelStyle}>WhatsApp Number <Required /></Grid>
                            <Grid item xs={12}>
                                <Autocomplete
                                    className={`${globalStyles.autocompleteParaphrasing} ${styles.autoComplete}`}
                                    options={getWhatsAppNumberOptions()}
                                    getOptionLabel={(option) => option.display_phone_number}
                                    value={getWhatsAppNumberValue()}
                                    onChange={(_, value: any) => { onChangeOfPhoneNumber(value); }}
                                    // disabled={checkDisableAllFields()}
                                    renderInput={(params) => <TextField {...params} placeholder="Select WhatsApp Number" />}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                }
            </Grid>
        </Grid>
    )
}

export default WorkflowFacebookIntegration